import { Box, HStack, VStack } from "@chakra-ui/react";
import { useState } from "react";
import useScreen from "../../hooks/useScreen";
import { DownloadPhotoButton } from "./DownloadPhotoButton/DownloadPhotoButton";
import { SeeOriginalPhotoButton } from "./SeeOriginalPhotoButton/SeeOriginalPhotoButton";
import { ShareLookButton } from "./ShareLookButton/ShareLookButton";
import { ShareOptionsButton } from "./ShareOptionsButton/ShareOptionsButton";

interface InteractiveButtonsProps {
  photo: string;
  handleShowOriginalPhoto: () => void;
  showOriginalPhoto: boolean;
  gnomeId: string;
}

export const InteractiveButtons = (props: InteractiveButtonsProps) => {
  const {
    photo,
    handleShowOriginalPhoto,
    showOriginalPhoto,
    gnomeId,
  } = props;
  const [showShareOptions, setShowShareOptions] = useState(false);
  const { isMobile } = useScreen();
  return (
    <>
      <HStack
        alignItems={"start"}
        spacing={3}
        position="absolute"
        top={{ base: "40px", md: "30px" }}
        right={{
          base: isMobile
            ? window.innerWidth < 512
              ? 5
              : (window.innerWidth - 492) / 2 + 10
            : 5,
          md: -10,
        }}
        zIndex={1}
      >
        <VStack>
          <ShareOptionsButton
            showShareOptions={showShareOptions}
            setShowShareOptions={setShowShareOptions}
          />
          {showShareOptions && (
            <>
              <ShareLookButton imageUrl={photo} gnomeId={gnomeId} />
              <DownloadPhotoButton imageUrl={photo} gnomeId={gnomeId} />
            </>
          )}
        </VStack>
      </HStack>
      <Box
        position="absolute"
        top={{ base: 9, md: "20px" }}
        left={{
          base: isMobile
            ? window.innerWidth < 512
              ? 5
              : (window.innerWidth - 492) / 2 + 10
            : 5,
          md: 5,
        }}
        zIndex={1}
      >
        <SeeOriginalPhotoButton
          chengeImage={handleShowOriginalPhoto}
          showOriginalPhoto={showOriginalPhoto}
        />
      </Box>
    </>
  );
};
